export default function OurAchievements() {
  return (
    <div className="w-full bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20">
      <div className="max-w-6xl mx-auto">
        {/* Header Container */}
        <div className="flex flex-col gap-2 mb-12 lg:mb-16 max-w-4xl relative">
          <h1 className="text-primary text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%] w-full">
            Our Achievements
          </h1>
          <p className="text-sm md:text-base leading-[150%] font-medium text-[#666666] font-urbanist">
            Our story is one of continuous growth and evolution. We started as
            a small team with big dreams, determined to create a real estate
            platform that transcended the ordinary.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {/* Card 1: 3+ Years of Excellence */}
          <div className="flex flex-col gap-3 p-4 md:p-5 lg:p-6 border border-gray-200 bg-white shadow-lg overflow-hidden">
            <h2 className="text-base md:text-lg font-semibold leading-[150%] text-black font-urbanist">
              3+ Years of Excellence
            </h2>
            <p className="text-xs md:text-sm font-medium leading-[150%] text-[#666666] font-urbanist">
              With over 3 years in the industry, we've amassed a wealth of
              knowledge and experience.
            </p>
          </div>

          {/* Card 2: Happy Clients */}
          <div className="flex flex-col gap-3 p-4 md:p-5 lg:p-6 border border-gray-200 bg-white shadow-lg overflow-hidden">
            <h2 className="text-base md:text-lg font-semibold leading-[150%] text-black font-urbanist">
              Happy Clients
            </h2>
            <p className="text-xs md:text-sm font-medium leading-[150%] text-[#666666] font-urbanist">
              Our greatest achievement is the satisfaction of our clients.
              Their success stories fuel our passion for what we do.
            </p>
          </div>

          {/* Card 3: Industry Recognition */}
          <div className="flex flex-col gap-3 p-4 md:p-5 lg:p-6 border border-gray-200 bg-white shadow-lg overflow-hidden">
            <h2 className="text-base md:text-lg font-semibold leading-[150%] text-black font-urbanist">
              Industry Recognition
            </h2>
            <p className="text-xs md:text-sm font-medium leading-[150%] text-[#666666] font-urbanist">
              We've earned the respect of our peers and industry leaders, with
              accolades that reflect our commitment to excellence.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

